import { render, staticRenderFns } from "./MnemonicosContrato.vue?vue&type=template&id=17b24a52&"
import script from "./MnemonicosContrato.vue?vue&type=script&lang=js&"
export * from "./MnemonicosContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports